import React from 'react';
import { Table, Button, Tooltip, Space } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Template } from './types';

interface TemplateTableProps {
  templates: Template[];
  onEdit: (template: Template) => void;
  onDelete: (template: Template) => void;
}

const TemplateTable: React.FC<TemplateTableProps> = ({
  templates,
  onEdit,
  onDelete
}) => {
  const formatTime = (timeStr: string) => {
    if (!timeStr) return '-';
    const d = new Date(timeStr);
    return d.toLocaleString();
  };

  const templateColumns = [
    {
      title: '项目名称',
      dataIndex: 'project_name',
      key: 'project_name',
      width: 120,
    },
    {
      title: '模板名称',
      dataIndex: 'template_name',
      key: 'template_name',
      width: 150,
    },
    {
      title: '标签级别',
      dataIndex: 'label_levels',
      key: 'label_levels',
      width: 100,
    },
    {
      title: '创建者',
      dataIndex: 'created_by',
      key: 'created_by',
      width: 100,
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 160,
      render: formatTime
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      render: (_: any, record: Template) => (
        <Space>
          <Button icon={<EditOutlined />} size="small" onClick={() => onEdit(record)}>编辑</Button>
          <Button icon={<DeleteOutlined />} size="small" danger onClick={() => onDelete(record)}>删除</Button>
        </Space>
      )
    },
  ];

  return (
    <Table
      columns={templateColumns}
      dataSource={templates}
      pagination={false}
      bordered
      rowKey="_id"
      size="middle"
    />
  );
};

export default TemplateTable;
